// ToggleButton.tsx

import { IconMoonStars, IconSun } from '@tabler/icons-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '@/plugins/auth'
import {
  getDefaultBannerImage,
  getDefaultProfileImage,
} from '@/plugins/auth/AuthProvider/effects/functions'

import useLocalStorage from '../../hooks/useLocalStorage'
import { StoredTheme, UserIdentity } from '../../utils/utils'
import RootButton from './RootButton'

const DarkModeButton: React.FC = () => {
  const { t } = useTranslation()
  const { address } = useAuth()
  const [userTheme, setUserTheme] = useLocalStorage<StoredTheme>(`userTheme`)
  const [userIdentity, setUserIdentity] = useLocalStorage<UserIdentity>(`userIdentity-${address}`)

  const toggleMode = () => {
    const isLightMode = !userTheme?.isLightMode
    setUserTheme({
      ...userTheme,
      isLightMode,
    })
    if (userIdentity) {
      setUserIdentity({
        ...userIdentity,
        profileImage: !userIdentity.profileImage.startsWith('ipfs://')
          ? getDefaultProfileImage(isLightMode)
          : userIdentity.profileImage,
        bannerImage: !userIdentity.bannerImage.startsWith('ipfs://')
          ? getDefaultBannerImage(isLightMode)
          : userIdentity.bannerImage,
      })
    }
  }

  return (
    <RootButton
      secondary
      onClick={toggleMode}
      leftSection={!userTheme?.isLightMode ? <IconSun /> : <IconMoonStars />}
    >
      {!userTheme?.isLightMode
        ? t('common.theme.lightMode', 'Light Mode')
        : t('common.theme.darkMode', 'Dark Mode')}
    </RootButton>
  )
}

export default DarkModeButton
